import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Input,
  Text,
} from '@chakra-ui/react';
import type { Dispatch } from 'react';

import type { TabContentAction } from '../PageConfigProvider/page-reducer';
import type { PositionedItem } from '../PageConfigProvider/types/item';
import labelStyles from './section-label.module.css';

type DivergingBarComboSettingsProps = {
  item: PositionedItem;
  dispatch: Dispatch<TabContentAction>;
};

export const DivergingBarComboSettings = ({
  item,
  dispatch,
}: DivergingBarComboSettingsProps) => {
  const id = item?.id;
  const combo = item?.plot?.divergingBarCombo;

  return (
    <AccordionItem borderTop="none">
      <h2>
        <AccordionButton width="100%" paddingLeft={2} paddingRight=".625rem">
          <Text
            className={labelStyles.sectionLabel}
            as="span"
            flex="1"
            textAlign="left"
            fontSize="sm"
            fontWeight="600"
          >
            Combo labels
          </Text>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel>
        <Flex direction="column" gap={3}>
          <Box>
            <Text fontSize="sm" fontWeight="500" mb={1}>
              Comparison Label
            </Text>
            <Input
              size="sm"
              placeholder="Comparison"
              value={combo?.comparisonLabel ?? ''}
              onChange={(e) => {
                dispatch({
                  type: 'UPDATE_ITEM_DIVERGING_BAR_COMBO',
                  payload: {
                    id,
                    divergingBarCombo: {
                      ...combo,
                      comparisonLabel: e.target.value,
                    },
                  },
                });
              }}
            />
          </Box>
          <Box>
            <Text fontSize="sm" fontWeight="500" mb={1}>
              Difference Label
            </Text>
            <Input
              size="sm"
              placeholder="Difference"
              value={combo?.differenceLabel ?? ''}
              onChange={(e) => {
                dispatch({
                  type: 'UPDATE_ITEM_DIVERGING_BAR_COMBO',
                  payload: {
                    id,
                    divergingBarCombo: {
                      ...combo,
                      differenceLabel: e.target.value,
                    },
                  },
                });
              }}
            />
          </Box>
        </Flex>
      </AccordionPanel>
    </AccordionItem>
  );
};
